module.exports = __webpack_public_path__ + "assets/icons/temperature.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/svg/temperature.svg
// module id = RXTU
// module chunks = 1